import classNames from "classnames";
import { PropsWithChildren } from "react";

interface HorizontalScrollProps extends PropsWithChildren {
  className?: string;
}

export const HorizontalScroll = ({ className, children }: HorizontalScrollProps) => {
  return (
    <div data-testid="horizontal-scroll" className={classNames("scroll-smooth overflow-x-scroll", className)}>
      {children}
    </div>
  );
};
